import React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material';

const Root = styled('div')(({ theme }) => ({
	padding: '0 7px',
	fontSize: 11,
	fontWeight: 600,
	height: 20,
	minWidth: 20,
	borderRadius: 20,
	display: 'flex',
	alignItems: 'center',
	backgroundColor: theme.palette.secondary.main,
	color: theme.palette.secondary.contrastText
}));

interface FuseNavBadgeProps {
	className?: string;
	badge: {
		title: React.ReactNode;
		bg?: string;
		fg?: string;
	};
}

function FuseNavBadge({ className, badge }: FuseNavBadgeProps) {
	return (
		<Root
			className={clsx(className, 'item-badge')}
			style={{
				backgroundColor: badge.bg,
				color: badge.fg
			}}
		>
			{badge.title}
		</Root>
	);
}

export default React.memo(FuseNavBadge);
